import React from 'react';
import PropTypes from 'prop-types';
import { getRecordData } from 'utils/tools';
import FormUploadAvatar from '../../form/FormUploadAvatar';
import { RestInputContext } from '../RestInputContext';

const RestFormInput = (props) => (
  <RestInputContext.Consumer>
    {({ record, form }) => (
      <FormUploadAvatar
        record={record}
        form={form}
        defaultValue={
          form.getFieldValue(props.source) ||
          getRecordData(record, props.source)
        }
        {...props}
      />
    )}
  </RestInputContext.Consumer>
);

RestFormInput.propTypes = {
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  record: PropTypes.object,
};

export default RestFormInput;
